export const normaliseUnderscores = (value: string) => value.replaceAll('_', '-');
